<template>
  <b-row style="position:relative">
    <b-col cols="12" ref="l">
      <div class="filters-container">
        <DropdownColumns v-model="fields" class="customize"/>
      </div>
      <b-table
        id="liability-counters-table"
        :busy.sync="isBusy"
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :hover="true"
        :striped="true"
        stacked="md"
        :items="provider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template v-slot:empty="scope">
          <div class="text-center">{{ $t(scope.emptyText) }}</div>
        </template>

        <template v-slot:head(eevent_id)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(combination)="data">{{ $t(data.label) }}</template>
        <template v-slot:head(value)="data">{{ $t(data.label) }}</template>
      </b-table>
      <div class="container-fluid">
        <div class="row">
          <div style="white-space:nowrap;" class="my-2">
            <PaginationSelect
              v-model="perPage"
              :options="paginationOpts"
              variant="light"
              size="sm"
            />
            <span>
              &nbsp;
              <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                <span slot="end">{{currentPage * perPage}}</span>
                <span slot="total">{{totalRows}}</span>
              </i18n>
            </span>
            <b-button
              size="sm"
              @click.stop="$root.$emit('bv::refresh::table', 'liability-counters-table')"
              class="ml-2 refresh"
              variant="light"
              :title="$t('Refresh')"
            >
              <i class="icon-refresh"></i>
            </b-button>
          </div>
          <nav class="ml-auto mt-2">
            <b-pagination
              size="md"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </nav>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import DropdownColumns from "@/components/DropdownColumns";
import PaginationSelect from "@/components/PaginationSelect";

export default {
  name: "liabilityCounters",
  components: {
    DropdownColumns,
    PaginationSelect
  },
  props: ["event_id"],
  data: function() {
    return {
      tableName: "liabilityCounters",
      isBusy: false,
      sortBy: "value",
      sortDesc: true,
      fields: [
        { key: "combination", sortable: true, class: "" },
        { key: "value", sortable: true, class: "" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,

      filter: null,
      filterField: null
    };
  },
  computed: {
    paginationOpts() {
      return [
        {
          value: 5
        },
        {
          value: 10
        },
        {
          value: 15
        },
        {
          value: 25
        },
        {
          value: 50
        }
      ];
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "liability-counters-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
        exactFields: ["event_id"],
        exactValues: [[this.event_id]]
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      this.$store
        .dispatch("liabilityCounter/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/liability-counters/" + item.eid);
    },
    redirect() {
      this.$router.push("/liability-counters/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


